import { createActionConfig } from './create-action-config';

export const type = '@appcues/conditional';
export const getConditional = ({ checks = [], on = 'tap' }) =>
  createActionConfig({
    on,
    type,
    config: {
      checks,
    },
  });
